import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=67f95af5&scoped=true"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./InventoryDashboard.vue?vue&type=style&index=0&id=67f95af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f95af5",
  null
  
)

export default component.exports